const APP_NAME = 'Zipteam';

const CACHE_SIZES = Object.freeze({
  SKILL: 5,
  SKILL_SUGGESTION: 30,
  TENANT_USER_SKILL: 5,
  USER_SUGGESTION: 30,
});

const CONTACTS = Object.freeze({
  GENERAL_SUPPORT: 'support@zipteam.com',
});

const DEFAULT_VALUES = Object.freeze({
  NEW_USER: {
    /*
      Keep keys in lowercase as they match the form's default values
      where case sensitivity is important.
    */
    disablePromotion: false,
    languageCode: 'en',
    timezoneCode: 'America/Los_Angeles',
  },
});

const DIALOG_NAMES = Object.freeze({
  COMPLETE_SURVEY_PRIMARY: 'complete-survey-primary',
  DELETE_SURVEY_PRIMARY: 'delete-survey-primary',
  REVOKE_TENANT_USER_COEDIT_PRIMARY: 'revoke-tenant-user-coedit-primary',
});

const EXTERNAL_LINKS = Object.freeze({
  CALIFORNIA_NOTICE: 'https://www.zipteam.com/ccpa',
  CONTACT_SUPPORT: 'mailto:support@zipteam.com',
  HELP_CENTER: 'https://zipteam.zendesk.com/hc/en-us',
  LANDING_PAGE: 'https://www.zipteam.com',
  PRIVACY_POLICY: 'https://www.zipteam.com/privacy',
  TERMS_OF_SERVICE: 'https://www.zipteam.com/terms',
});

const IMAGE_FILES = Object.freeze({
  LOGO: Object.freeze({
    PRIMARY: 'zipteam-icon.svg',
    SECONDARY: 'zipteam-logo.svg',
  }),
  PLACEHOLDER: Object.freeze({
    PRIMARY: 'eye_glass.png',
    SECONDARY: 'robot.png',
    USER: 'user.svg',
  }),
  TENANT: Object.freeze({
    CREATE: 'create-workspace.png',
  }),
  TUTORIAL: Object.freeze({
    STEP1: 'feather.png',
    STEP2: 'contact.png',
    STEP3: 'star.png',
  }),
});

const INPUT_MAX_LENGTHS = Object.freeze({
  TENANT_NAME: 128,
});

const INPUT_MIN_LENGTHS = Object.freeze({
  SKILL_SUGGESTION: 3,
  STRICT_SKILL_SUGGESTION: 1,
  TENANT_NAME: 1,
  USER_SUGGESTION: 2,
});

const LENGTH_LIMITS = Object.freeze({
  COEDIT_SKILL_TAGS_LENGTH_MAX: 5,
  JOIN_LIST_MAX: 5,
  TENANT_USER_LINKS_LENGTH_MAX: 3,
});

const MIN_WIDTHS = Object.freeze({
  SMALL: '576px',
  MEDIUM: '768px',
  LARGE: '992px',
  XLARGE: '1200px',
});

const MODAL_WINDOW_NAMES = Object.freeze({
  ADD_REQUIRED_SKILLS_PRIMARY: 'add-tenant-team-required-skills-primary',
  CONFIGURE_SURVEY_PRIMARY: 'configure-survey-primary',
  CONFIGURE_TENANT_USER_SKILL_PRIMARY: 'configure-tenant-user-skill-primary',
  CREATE_SURVEY_PRIMARY: 'create-survey-primary',
  CREATE_TENANT_PRIMARY: 'create-tenant-primary',
  CREATE_TENANT_TEAM_PRIMARY: 'create-tenant-team-primary',
  DELETE_TENANT_PRIMARY: 'delete-tenant-primary',
  DELETE_TENANT_TEAM_PRIMARY: 'delete-tenant-team-primary',
  DELETE_TENANT_USER_PRIMARY: 'delete-tenant-user-primary',
  CREATE_OTHER_TENANT_USER_SKILL_PRIMARY: 'create-other-tenant-user-skill-primary',
  DELETE_TENANT_TEAM_TENANT_USER_PRIMARY: 'delete-tenant-team-tenant-user-primary',
  HELP_PRIMARY: 'help-priamry',
  INTRODUCE_ENTERPRISE_LICENSE_PRIMARY: 'introduce-enterprise-license-primary',
  INVITE_TO_TENANT_PRIMARY: 'invite-to-tenant-primary',
  PUBLISH_SURVEY_PRIMARY: 'publish-survey-primary',
  RENAME_SURVEY_PRIMARY: 'rename-survey-primary',
  RENAME_TENANT_TEAM_PRIMARY: 'rename-tenant-team-primary',
  SHARE_SURVEY_PRIMARY: 'share-survey-primary',
  SHARE_TENANT_TEAM_LINK_PRIMARY: 'share-tenant-team-link-primary',
  UPDATE_TENANT_USER_PRIMARY: 'update-tenant-user-primary',
  UPLOAD_USER_IMAGE_PRIMARY: 'upload-user-image-primary',
  WRAP_UP_SURVEY_PRIMARY: 'wrap-up-survey-primary',
});

const PAGE_SIZES = Object.freeze({
  DEFAULT: 10,
  SURVEY: 11,
  SURVEY_RESPONSE: 10,
  TENANT_USER_COEDIT: 5,
  USER_TENANT: 11,
});

const ROLE_TYPE_CODES = Object.freeze({
  GENERAL: 0,
  ADMIN: 100,
});

const ROLE_TYPE_DISPLAY_NAMES = Object.freeze({
  0: 'Member',
  100: 'Admin',
});

const SEARCH_EXPERT_PARAMS = Object.freeze({
  MODE: Object.freeze({
    BY_PERSON_NAME: 'name',
    BY_SKILL_NAME: 'skill',
  }),
  SUGGESTION_LENGTH: 7,
});

const USER_PROFILE_LIMITS = Object.freeze({
  IMAGE_SIZE_MAX_KB: 5000,
  IMAGE_COMPRESSION_SIZE_MAX_KB: 200,
  IMAGE_COMPRESSION_MAX_SIZE: 200,
});

const WIDTH_LIMITS = Object.freeze({
  HEADER: Object.freeze({
    EXPAND: '768px',
    WORDMARK: '576px',
  }),
});

const Z_INDEXES = Object.freeze({
  HOME: Object.freeze({
    SEARCH_BOX: 100,
  }),
  LAYOUT: Object.freeze({
    HEADER: 999,
    HEADER_NAVIGATION_DROPDOWN: 999,
    HEADER_USER_DROPDOWN: 999,
  }),
  MODAL: Object.freeze({
    CONFIGURE_TENANT_USER_SKILL: Object.freeze({
      DROPDOWN: 100,
    }),
  }),
  SEARCH: Object.freeze({
    SEARCH_BOX: 100,
  }),
  SKILL_EXPLORER: Object.freeze({
    CONTROL_PANEL: 10,
  }),
  TEAMUP: Object.freeze({
    HEADER_DROPDOWN: 101,
    SEARCH_BOX: 100,
  }),
  USER: Object.freeze({
    SKILL_GRAPH: 10,
  }),
});

export {
  APP_NAME,
  CACHE_SIZES,
  CONTACTS,
  DEFAULT_VALUES,
  DIALOG_NAMES,
  EXTERNAL_LINKS,
  IMAGE_FILES,
  INPUT_MAX_LENGTHS,
  INPUT_MIN_LENGTHS,
  LENGTH_LIMITS,
  MIN_WIDTHS,
  MODAL_WINDOW_NAMES,
  PAGE_SIZES,
  ROLE_TYPE_CODES,
  ROLE_TYPE_DISPLAY_NAMES,
  SEARCH_EXPERT_PARAMS,
  USER_PROFILE_LIMITS,
  WIDTH_LIMITS,
  Z_INDEXES,
};
